import React, { useState, useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import axios from 'axios';

const PrivateRoute = ({ element, isAuthenticated }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [checking, setChecking] = useState(!isAuthenticated);
  const [isAuth, setIsAuth] = useState(isAuthenticated);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setChecking(true);
      setError(null);

      // Перепроверяем сессию для уверенности
      axios.get('/api/auth/check-session', { withCredentials: true })
        .then(res => {
          if (res.data && res.data.authenticated) {
            console.log('Session check success: User is authenticated');
            setIsAuth(true);
          } else {
            console.log('Session check result: User is NOT authenticated, redirecting to login');
            setIsAuth(false);
            
            // Явное перенаправление на страницу логина
            setTimeout(() => {
              navigate('/login', { state: { from: location, message: 'Your session has expired. Please log in again.' } });
            }, 100);
          }
        })
        .catch(err => {
          console.error('Session check failed:', err);
          setIsAuth(false);
          setError('Authentication check failed. Please try again.');
          
          // Явное перенаправление на страницу логина при ошибке
          setTimeout(() => {
            navigate('/login', { state: { from: location, message: 'Authentication error. Please log in again.' } });
          }, 100);
        })
        .finally(() => {
          setChecking(false);
        });
    } else {
      setIsAuth(true);
      setChecking(false);
    }
  }, [isAuthenticated, location, navigate]);

  if (checking) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <CircularProgress sx={{ mb: 2 }} />
        <Typography variant="body1" color="text.secondary">
          Verifying your session...
        </Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <Typography variant="h6" color="error" gutterBottom>
          {error}
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Redirecting to login...
        </Typography>
      </Box>
    );
  }

  return isAuth ? (
    element
  ) : (
    <Navigate to="/login" state={{ from: location, message: 'Please log in to access this page.' }} replace />
  );
};

export default PrivateRoute;